import { connect } from 'react-redux';
import { VerifyProvider } from './VerifyProvider';
import { gitIntegrationsSelector } from 'state/selectors/sensors-authorizations';
import { myAccountSelector } from 'state/selectors/account';

const mapStateToProps = state => ({
  account: myAccountSelector(state),
  gitSensorAuthorizations: gitIntegrationsSelector(state)
});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(VerifyProvider);
